import $ from 'jquery';
import Config from './ClientConfig';
import checkLocalStorage from './checkLocalStorage';
import swal from 'sweetalert';

import SimpleBIConfig from './../Config';
var sprintf = require('sprintf-js').sprintf;

function showApiUnavailableError(xhr) {
    if (xhr?.status === 0 || xhr?.status === 502 || xhr?.status === 503 || xhr?.status === 504) {
        if (typeof window.__showBootError === "function") {
            window.__showBootError();
        }
    }
}

export function isAuthTokenValid(token){
    var tokenMeta = JSON.parse(atob(token.split(".")[1]));
    var expiry = new Date(tokenMeta.exp  * 1000);
    var current = new Date();
    if (current>expiry){
        return false;
    } else {
        return true;
    }
}

export default class Client {
    constructor (){
        this.accessToken = "";
        this.refreshToken = "";
        this.user = {};
        checkLocalStorage();
        if (localStorage.length > 0){
            var data = JSON.parse(localStorage.getItem("apiUser"));
            if (data !== null && data.accessToken !== undefined && isAuthTokenValid(data.accessToken)){
                this.profile = data.profile;
                this.accessToken = data.accessToken;
                this.refreshToken = data.refreshToken;
            } else {
                localStorage.clear()
            }
        }

        var self = this;
        
        $.ajaxSetup({
            crossDomain:true,
            beforeSend: function(xhr) {
                    if (self.getAuthToken().length > 0)
                xhr.setRequestHeader('Authorization', 'Bearer ' + self.getAuthToken());
            }
        })
    };

    // fuck this!
    getAuthToken () {
        return this.accessToken;
    }

    isAccessTokenValid ( token ) {
        return isAuthTokenValid ( token );
    }

    auth (username, password, callback = function(){}) {
        var data = {
            "username": username,
            "password": password
        };
        var that = this;
        // let authURL = Config.AUTH_API_URL;
        let authURL = /^https?:\/\//i.test(Config.AUTH_API_URL)
            ? Config.AUTH_API_URL
            : ((that.prefix || "") + (Config.AUTH_API_URL.startsWith("/") ? Config.AUTH_API_URL : "/" + Config.AUTH_API_URL));
        if (that.prefix !== undefined)
            authURL = that.prefix + Config.AUTH_API_URL;
        $.ajax({
            url: authURL,
            data: JSON.stringify(data),
            type: "POST",
            // Let the login error handler show failed credentials without a page reload.
            global: false,
            contentType: 'application/json',
            processData: false,
            async: true,
            success:function(data){
                if ("access" in data){
                    that.accessToken = data["access"];
                    that.refreshToken = data["refresh"];
                    $.ajax({
                        // url: that.prefix + Config.WHOAMI_API_URL,
                        url: /^https?:\/\//i.test(Config.WHOAMI_API_URL)
                            ? Config.WHOAMI_API_URL
                            : ((that.prefix || "") + (Config.WHOAMI_API_URL.startsWith("/") ? Config.WHOAMI_API_URL : "/" + Config.WHOAMI_API_URL)),
                        type: "GET",
                        contentType: 'application/json',
                        processData: true,
                        async: true,
                        success:function(data){
                            that.profile = data.profile;
                            localStorage.setItem("apiUser", JSON.stringify({
                                "profile": that.profile,
                                "accessToken": that.accessToken,
                                "refreshToken": that.refreshToken,
                                "time": (new Date()).getTime(),
                                }));
                            window.location.href = SimpleBIConfig.MAIN_URL;
                        },
                        error: function(xhr, status, error){
                            that.logout();
                        }
                    })
                }
            },
            error: function(xhr, status, error){
                swal({
                    text: xhr.status === 401
                        ? "Wrong username or password."
                        : xhr.status === 400
                            ? "Please check your username and password."
                            : xhr.status === 0
                                ? "Could not reach the server. Please try again."
                                : "Unable to sign in right now. Please try again later.",
                    icon: "error",
                  });
            }
        })
    }

    logout (callback = function(){}) {
        if (localStorage.length > 0 || this.user.username){
            var that = this;
            $.ajax({
                url: that.prefix + Config.LOGOUT_API_URL,
                type: "get",
                contentType: 'application/json',
                processData: false,
                async: false,
                success: function(){
                    that.user = {};
                    var data = JSON.parse(localStorage.getItem("apiUser"));
                    localStorage.removeItem("apiUser");
                    //window.location.href =  that.prefix;
                },
                error: function(xhr, status, error){
                    //window.location.href = that.prefix;
                }
            })
        }
    }

    reset () {
        this.accessToken = "";
        this.refreshToken = "";
        this.prefix = window.location.protocol + "//" + window.location.host;
        this.user = {};
    }

    getConfig ( queryData, callback = function(){} ) {
        var that = this;
        var result = null;
        $.ajax( {
            async: false,
            data: queryData,
            type: 'GET',
            // url: that.prefix + Config.API_URL_CONFIG_FRONT,
            url: Config.BASE_URL + Config.API_URL_CONFIG_FRONT,
            headers: { 
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            contentType: 'application/json',
            cache: false,
            format: 'jsonp',
            success: function (msg) {
                    result = msg;
            },
            error: function(xhr, status, error){
                console.log("getting Data failed: " + error);
                showApiUnavailableError(xhr);
            }
        } );
        return result;
    }

    setConfigLocalStorage ( callback = function(){} ) {
        let queryData = { };
        let cData = this.getConfig ( queryData );
        let platform = { };
        let identityTexts = { };
        let identityImages = { };
        Object.keys(cData).forEach(key => {
            let fData = cData [ key ];
            switch ( key ) {
            case "platform":
                fData.map ( (d) => {
                platform [ d.key ] = d.value;
                });
                break;

            case "identityTexts":
                fData.map ( (d) => {
                identityTexts [ d.key ] = d.value;
                });
                break;

            case "identityImages":
                fData.map ( (d) => {
                identityImages [ d.key ] = d.image;
                });
                break;
            }     
        });
        let config = { };
        config [ "platform" ] = platform;
        config [ "identityTexts" ] = identityTexts;
        config [ "identityImages" ] = identityImages;
        localStorage.setItem ( "config",  JSON.stringify(config) );
    }

    setLanguagesLocalStorage ( callback = function(){} ) {
        var that = this;
        var result = null;
        $.ajax( {
            async: false,
            type: 'GET',
            data: "",
            url: that.prefix + Config.API_URL_LANGUAGE,
            headers: { 
                'Accept': 'application/json',
                'Content-Type': 'application/json' 
            },
            contentType: 'application/json',
            cache: false,
            format: 'json',
            success: function (msg) {
                result = msg;
                localStorage.setItem ( "languages",  JSON.stringify(result.Languages) );
            },
            error: function(xhr, status, error){
                console.log("getting languages failed: " + error);
            }
        } );
        return result;
    }    

    getGeoData ( queryData, callback = function(){} ) {
        var that = this;
        var result = null;
        $.ajax( {
            async: false,
            data: queryData,
            type: 'GET',
            url: that.prefix + Config.API_URL_GEODATA,
            headers: { 
                'Accept': 'application/json',
                'Content-Type': 'application/json' 
            },
            contentType: 'application/json',
            cache: false,
            format: 'json',
            success: function (msg) {
                    result = msg;
            },
            error: function(xhr, status, error){
                console.log("getting Geo Data failed: " + error);
            }
        } );
        return result;
    }

    getData ( url, queryData, callback = function(){} ) {
        var that = this;
        var result = null;
        $.ajax( {
            async: false,
            data: queryData,
            type: 'GET',
            // url: that.prefix + url,
            url: url,
            headers: { 
                'Accept': 'application/json',
                'Content-Type': 'application/json' 
            },
            contentType: 'application/json',
            cache: false,
            format: 'json',
            success: function (msg) {
                    result = msg;
            },
            error: function(xhr, status, error){
                console.log("getting Data failed: " + error);
                showApiUnavailableError(xhr);
            }
        } );
        return result;
    }

    getDataAsync ( url, queryData = {} ) {
        return $.ajax( {
            async: true,
            data: queryData,
            type: 'GET',
            url: url,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            contentType: 'application/json',
            cache: false,
            format: 'json'
        } );
    }

    postDataAsync ( url, data = {} ) {
        return $.ajax( {
            async: true,
            type: 'POST',
            url: url,
            data: JSON.stringify(data),
            processData: false,
            headers: { 'Accept': 'application/json' },
            contentType: 'application/json',
            timeout: 30000
        } );
    }

    pushData ( url, queryData, callback = function(){} ) {
        var that = this;
        var result = null;
        const _queryData = Object.assign ( {}, queryData );    
        $.ajax( {
            async: false,
            data: _queryData,
            type: 'POST',
            // url: that.prefix + url,
            url: url,
            /* headers: { 
                'Accept': 'application/json',
                'Content-Type': 'application/json' 
            },
            contentType: 'application/json', */
            cache: false,
            format: 'json',
            success: function (msg) {
                    result = msg;
            },
            error: function(xhr, status, error){
                //console.log("pushing Data failed: " + error + " -> " + status + " -> " + xhr );
                result = xhr.responseJSON;
            }
        } );
        return result;
    }
    
    callExternalAPI ( url, queryData, callback = function(){} ) {
        var that = this;
        var result = null;
        $.ajax( {
            async: false,
            data: queryData,
            type: 'GET',
            url: that.prefix + url,
            headers: { 
                'Accept': 'application/json',
                'Content-Type': 'application/json' 
            },
            contentType: 'application/json',
            cache: false,
            format: 'json',
            success: function (msg) {
                    result = msg;
            },
            error: function(xhr, status, error){
                console.log("Calling external API failed: " + error);
            }
        } );
        return result;
    }

    forgotPassword(username, callback=function(){}){
        var that = this;
        $.ajax( {
            async: true,
            type: 'GET',
            url: that.prefix + Config.FORGOTPASS_API_URL,
            cache: false,
            data: {username: username},
            processData: true,
            success: function(data){
                        swal({
                            text: "Forgot password...",
                            icon: "success",
                        }).then((value)=>{
                            callback();
                            window.location.href = "/";
                        });
                    },
            error: function(xhr, status, error){
               
            }
        } );
    }

    resetPass(data, callback = function(){}){
        var that = this;
        $.ajax( {
            async: true,
            type: 'POST',
            //url: base_url + select,
            url: that.prefix + Config.RESETPASS_API_URL,
            // contentType: 'application/json',
            cache: false,
            data: data,
            processData: true,
            success: function(data){
                        callback();
                    },
            error: function(xhr, status, error){
                swal({
                    text: "Send message...",
                    icon: "error",
                  });
            }
        } );
    }
};
